import { useEffect, useState } from 'react';
import { erpList } from '../../../services/erpApi';

// Loads customers, vendors, skus once per mount for form pickers.
export const useMasters = (keys = ['customers', 'skus']) => {
  const [m, setM] = useState({ customers: [], vendors: [], skus: [], companies: [] });
  useEffect(() => {
    Promise.all(keys.map((k) => erpList(k).then((r) => [k, r.data.items || []]).catch(() => [k, []])))
      .then((pairs) => setM((s) => ({ ...s, ...Object.fromEntries(pairs) })));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return m;
};

export const partyOpts = (rows) => rows.map((c) => ({ value: c.id, label: c.name, sub: `${c.code}${c.state ? ` · ${c.state}` : ''}` }));
